import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioConversor } from '../../conversao';
import { NegocioQualificacaoSearch } from '../negocio-qualificacao-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioQualificacaoConversaoHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negocioqualificacao`;
    }

    /** Realiza a conversão de uma qualificação de negócio */
    converter(conversor: NegocioConversor): Observable<NegocioQualificacaoSearch> {
        return this.customHttp.put<NegocioQualificacaoSearch>(`${this.pathApi}/${conversor.idNegocio}/converter`, conversor);
    }
}
